import { render, staticRenderFns } from "./AdFeeAlertModal.vue?vue&type=template&id=2769d774&"
import script from "./AdFeeAlertModal.vue?vue&type=script&lang=js&"
export * from "./AdFeeAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./AdFeeAlertModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1149100511/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2769d774')) {
      api.createRecord('2769d774', component.options)
    } else {
      api.reload('2769d774', component.options)
    }
    module.hot.accept("./AdFeeAlertModal.vue?vue&type=template&id=2769d774&", function () {
      api.rerender('2769d774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AdFeeAlertModal.vue"
export default component.exports